import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { adminTheme } from '../styles/adminTheme';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <StyledThemeProvider theme={adminTheme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;